<template>
  <div class="marketing TopHeadder">
      <!-- 智能营销 -->
      <div class="bannerBox">
          <img src="../../assets/image/m_banner.png" />
          <div class="bannerTitle">
             <h3>智能外呼机器人iCall</h3>
             <p>智能高效的语音互动</p>
             <p>快速完成营销线索挖掘及客户服务回访</p>
          </div>
      </div>

     <div class="market_item1 PublicPadding">
         <h4 class="title">智能外呼，省时省力</h4>
         <p>小语智能语音机器人iCall，集ASR、NLP、TTS等AI智能语音技术和呼叫中心技术于一体，通过真人录制的声音模仿与客户进行多轮对话，并将语音转化为文字，准确判定客户意图，可应用于电话营销及客服回访等场景。在降低人力成本的基础上，帮助企业提升营销业绩及客服效率。</p>
         <i><img src="../../assets/image/ma1_1.png"/></i>
     </div>
     <!--行业应用案例试听-->
      <div class="PublicPadding colorbg">
          <h4 class="title">行业应用案例试听</h4>
          <div class="audioBox" id="audioBox"></div>
          <ul class="ulType2" id="audios">
              <li @click="audioBtn($event,0)">
                  <img src="../../assets/image/audio_pic1.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,1)">
                  <img src="../../assets/image/audio_pic2.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,2)">
                  <img src="../../assets/image/audio_pic3.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,3)">
                  <img src="../../assets/image/audio_pic4.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,4)">
                  <img src="../../assets/image/audio_pic5.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,5)">
                  <img src="../../assets/image/audio_pic6.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,6)">
                  <img src="../../assets/image/audio_pic7.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,7)">
                  <img src="../../assets/image/audio_pic8.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,8)">
                  <img src="../../assets/image/audio_pic9.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
              <li @click="audioBtn($event,9)">
                  <img src="../../assets/image/audio_pic10.png" class="li_pic">
                  <img src="../../assets/image/audio_start.png" class="li_start">
                  <img src="../../assets/image/audio_pause.png" class="li_pause">
              </li>
          </ul>
      </div>
      <div class="market_item3 PublicPadding">
          <h4 class="title">功能亮点</h4>
          <ul>
             <li class="m3_li1" :class="{active:activeChild==1}" v-on:click="activeTab(1)">
               <div>
                  <i></i>
                  <h3>智能外呼</h3>
               </div>
             </li>
             <li class="m3_li2" :class="{active:activeChild==2}" v-on:click="activeTab(2)">
               <div>
                  <i></i>
                  <h3>话术可视化配置</h3>
                </div>
             </li>
             <li class="m3_li3" :class="{active:activeChild==3}" v-on:click="activeTab(3)">
                <div>
                  <i></i>
                  <h3>意向客户判定</h3>
                </div>
             </li>
             <li class="m3_li4" :class="{active:activeChild==4}" v-on:click="activeTab(4)">
               <div>
                  <i></i>
                  <h3>移动端跟踪管理</h3>
                </div>
             </li>
             <li class="m3_li5" :class="{active:activeChild==5}" v-on:click="activeTab(5)">
               <div>
                 <i></i>
                 <h3>数据统计分析</h3>
                </div>
             </li>
             
          </ul>
          <ol>
             <li v-show="activeChild==1">
                <div>
                   <h3>智能外呼</h3>
                   <p>· 数据一键批量导入</p>
                   <p>· 灵活配置机器人工作时间</p>
                   <p>· 自动完成海量外呼任务</p>
                   <p>· 图表形式展现任务执行情况</p>       
                </div>
                <i>
                  <img src="../../assets/image/m_ol1.png"/>
                </i>
             </li>
              <li v-show="activeChild==2">
                <div>
                   <h3>话术可视化配置</h3>
                   <p>· 话术配置可视化，支持话术全局化、流程化、节点化配置，话术内容自由跳转等，实现用户多种业务场景；</p>
                   <p>· 支持TTS语音播放、支持忽略、语音打断、关键词打断多种响应方式。</p>     
                </div>
                <i>
                  <img src="../../assets/image/m_ol2.jpg"/>
                </i>
             </li>
             <li v-show="activeChild==3">
                <div>
                   <h3>意向客户判定</h3>
                   <p>· 业内优秀的分值决策系统，判断客户意向更准确;</p>
                   <p>· 自定义意向分值，通过客户沟通交流记录、沟通过程、经过节点等，描绘用户画像。</p>     
                </div>
                <i>
                  <img src="../../assets/image/m_ol3.jpg"/>
                </i>
             </li>
              <li v-show="activeChild==4">
               <div>
                   <h3>移动端跟踪管理</h3>
                   <p>· 支持手机小程序录音上传，操作更加快捷方便；</p>
                   <p>· 支持意向客户手机端推送，实时更新，及时跟进，不丢掉任何一个高意向客户；</p>  
                   <p>· 手机动态监督机器人运行情况、呼叫情况，实时预警。</p>     
                </div>
                <i>
                  <img src="../../assets/image/m_ol4.jpg"/>
                </i>
             </li>
             <li v-show="activeChild==5">
               <div>
                   <h3>数据统计分析</h3>
                   <p>· 智能外呼机器人ICALL支持各种数据分析统计，可结合用户个性化需求，进行报表定制化设计。</p>    
                </div>
                <i>
                  <img src="../../assets/image/m_ol5.jpg"/>
                </i>
             </li>
          </ol>
      </div>
      <div class="market_item4 PublicPadding colorbg">
        <h4 class="title">更多功能支撑，让外呼更有温度</h4>
        <ul>
           <li>
              <i><img src="../../assets/image/m4_1.png"/></i>
              <p>0.7S极速响应，支持多种打断方式，真人沟通体验</p>
           </li>
           <li>
              <i><img src="../../assets/image/m4_2.png"/></i>
              <p>	引入语境，上下文判读客户意向更精准</p>
           </li>
            <li>
              <i><img src="../../assets/image/m4_3.png"/></i>
              <p>	沟通话术节点数据呈现，客户总体意图更明确</p>
           </li>
            <li>
              <i><img src="../../assets/image/m4_4.png"/></i>
              <p>	通话内容全记录，录音转文字，查看更便捷</p>
           </li>
            <li>
              <i><img src="../../assets/image/m4_5.png"/></i>
              <p>	人机协作无间，智能转接人工，配合无间不丢单</p>
           </li>
            <li>
              <i><img src="../../assets/image/m4_6.png"/></i>
              <p>	话术训练学习，机器人工作更智能</p>
           </li>

        </ul>
      </div>
      <div class="market_item5">
         <h4 class="title">全面优质服务，让每一位用户满意</h4>
         <ul>
           <li>
                <i>
                    <img src="../../assets/image/jqr7.png"/>
                </i>
                <h3>产品使用培训</h3>
                <p>
                    指派专人进行产品的使用培训，保障每一位客户都能正常使用
                </p>
            </li>
            <li>
                <i>
                    <img src="../../assets/image/jqr8.png" />
                </i>
                <h3>话术库录入优化</h3>
                <p>
                    话术数据库建立初始，安排专人协助制作，并给出针对性建议
                </p>
            </li>
            <li>
                <i>
                    <img src="../../assets/image/jqr9.png" />
                </i>
                <h3>7x24小时保姆式服务</h3>
                <p>
                    人工客户+机器人客服全天候在线，实时解决客户问题
                </p>
            </li>
            <li>
                <i>
                    <img src="../../assets/image/jqr10.png" />
                </i>
                <h3>定期系统升级</h3>
                <p>
                    根据客户需求，对部署系统进行定期升级服务
                </p>
            </li>
         </ul>
      </div>
      <Popup v-show="$store.state.isshow"></Popup>
  </div> 
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'marketing',
  data () {
    return {
      activeChild:1,
       audioData:[
          {
            name:'房产',
            id:1,
            idName:'audio1',
            src:'https://www.xiaoyu168.com/audio/getvoice1.mp3',
            tf:false,
          },
          {
            name:'租赁',
            idName:'audio2',
            id:2,
            src:'https://www.xiaoyu168.com/audio/getvoice2.mp3',
            tf:false,
          },
          {
            name:'保险',
            idName:'audio3',
            id:3,
            src:'https://www.xiaoyu168.com/audio/getvoice3.mp3',
            tf:false,
          },
          {
            name:'互联网',
            idName:'audio4',
            id:4,
            src:'https://www.xiaoyu168.com/audio/getvoice4.mp3',
            tf:false,
          },
          {
            name:'教育',
            idName:'audio5',
            id:5,
            src:'https://www.xiaoyu168.com/audio/getvoice5.mp3',
            tf:false,
          },
          {
            name:'招聘',
            idName:'audio6',
            id:6,
            src:'https://www.xiaoyu168.com/audio/getvoice6.mp3',
            tf:false,
          },
          {
            name:'汽车',
            idName:'audio7',
            id:7,
            src:'https://www.xiaoyu168.com/audio/getvoice7.mp3',
            tf:false,
          },
          {
            name:'家装',
            idName:'audio8',
            id:8,
            src:'https://www.xiaoyu168.com/audio/getvoice8.mp3',
            tf:false,
          },
          {
            name:'招商',
            idName:'audio9',
            id:9,
            src:'https://www.xiaoyu168.com/audio/getvoice9.mp3',
            tf:false,
          },
          {
            name:'运营',
            idName:'audio10',
            id:10,
            src:'https://www.xiaoyu168.com/audio/getvoice10.mp3',
            tf:false,
          },
        ]
    }
  },
  components:{
        Popup
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
    audioBtn(el,num){
      //console.log(el.getElementsByTagName("li"))
      if(num>this.audioData.length){
          return;
      }

      let box=document.getElementById("audioBox");
      if(!this.audioData[num].tf){
          let newAudio = document.createElement('audio')
          newAudio.className = 'voice';
          newAudio.id = this.audioData[num].idName;
          newAudio.src = this.audioData[num].src;
          box.appendChild(newAudio);
          this.audioData[num].tf=true;
      }

      let className=el.currentTarget.className||'';
      let ul=document.getElementById("audios");
      let liArr=ul.getElementsByTagName("li");
      let liLen=liArr.length;
      for(let i=0;i<liLen;i++){
          console.log(i,liArr[i]);
          liArr[i].classList.remove("play");
      }
      for(let item of this.audioData){
          if(item.tf){
            let aDom=document.getElementById(item.idName);
            if(item.idName==this.audioData[num].idName){
                let audioTxt= '示例音频-'+item.name;
                if(!className){
                    el.currentTarget.classList.add("play");
                    aDom.play();
                    aDom.addEventListener('ended', function () {  
                        aDom.classList.remove("play");
                    }, false);
                    _hmt.push(['_trackEvent', audioTxt, '播放']);
                }else{
                    aDom.pause(); 
                    _hmt.push(['_trackEvent', audioTxt, '暂停']);
                }
            }else{
                aDom.pause(); 
            }
          }
      }
    },
    activeTab(num) {
       this.activeChild=num
    }, 
  }
}
</script>


<style scoped>
.audioBox{display: none;}
.bannerTitle h3{
  text-align: left;
}
.bannerTitle p{
  text-align: left;
}
.market_item1{
  padding-left:0.25rem;
  padding-right:0.25rem;
}
.market_item1 p{
  font-size: 0.2rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.4rem;
  padding: 0.4rem;
  box-shadow: 0 0 0.08rem #ccc;
  margin-top:0.5rem;
  margin-bottom: 0.7rem;
}
.market_item1 i{
  display: block;
  width:7rem;
  height: 16.62rem;
}
.market_item1 i img{
  display: block;
  width:7rem;
  height: 16.62rem;
}
.market_item3 ul{
  /* overflow: hidden; */
  height: 1.5rem;
  background: #eefefc;
  border-top:0.02rem solid #90e4f7;
  border-bottom:0.02rem solid #90e4f7;
  margin-top:0.4rem;
}

.market_item3 ul li{
  float: left;
  width: 1.496rem;
}
.market_item3 ul li div{
  height: 1.3rem;
  border-left: 0.01rem solid #90e4f7;
  padding-top: 0.2rem;
}
.market_item3 ul li.active{
  padding-bottom:0.2rem ;
}
.market_item3 ul li:first-child div{
  border-left: none;
}
.market_item3 ul li i{
  display: block;
  width: 0.3rem;
  height: 0.3rem;
  margin: 0 auto; 
  margin-bottom: 0.17rem;
}
.market_item3 ul li.m3_li1 i{
   background: url("../../assets/image/mk1_1.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2 i{
   background: url("../../assets/image/m3_2.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3 i{
   background: url("../../assets/image/m3_3.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4 i{
   background: url("../../assets/image/m3_4.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li5 i{
   background: url("../../assets/image/m3_5.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li1.active i{
   background: url("../../assets/image/m3_11.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2.active i{
   background: url("../../assets/image/mk1_22.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3.active i{
   background: url("../../assets/image/mk1_33.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4.active i{
   background: url("../../assets/image/mk1_44.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li5.active i{
   background: url("../../assets/image/mk1_55.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li h3{
  font-size: 0.18rem;
  font-weight: 400;
  color: #00C7FF;
  line-height: 0.3rem;
  width: 0.9rem;
  margin: 0 auto;
  padding-bottom:0.25rem ;
}
.market_item3 ul li.active{
  background:url("../../assets/image/m_li.png") no-repeat center;
  background-size:100% 100%;
}
.market_item3 ul li.active h3{
  color: #fff;
}
.market_item3 ol{
  width: 7rem;
  height: 4.56rem; 
  margin:0 auto;
  margin-top: 0.5rem;
  box-shadow: 0 0 0.08rem #ccc;
}
.market_item3 ol li{
  overflow: hidden;
}
.market_item3 ol li div{
  float: left;
}
.market_item3 ol li div h3{
  font-size: 0.3rem;
  font-weight: 400;
  color: #33CAF2;
  line-height: 0.3rem;
  margin: 0.8rem 0 0.3rem 0.3rem;
}
.market_item3 ol li div p{  
  font-size: 0.18rem;
  font-weight: 400;
  color: #666666;
  margin-top:0.2rem;
  margin-left: 0.3rem;
  width: 2.9rem;
}
.market_item3 ol li i{
  float: right;
  display: block;
  width:3.42rem;
  height: 3.82rem;
  margin:0.35rem 0.26rem 0 0;
}
.market_item3 ol li i img{
  display: block;
  width:3.42rem;
  height: 3.82rem;
}
.market_item4 ul{
  width: 7rem;
  margin: 0 auto;
  margin-top:0.4rem;
}
.market_item4 ul li{
  overflow: hidden;
  background: #fff;
  margin-bottom: 0.3rem;
  height: 1.36rem;
}
.market_item4 ul li i{
  float: left;
  width: 1.03rem;
  height: 0.97rem;
  margin:0.24rem 0 0 0.22rem;
}
.market_item4 ul li i img{
  display: block;
  width: 1.03rem;
  height: 0.97rem;
}
.market_item4 ul li p{
  font-size: 0.22rem;
  font-weight: 400;
  color: #666666;
  margin-top:0.53rem;
  padding-left: 1.5rem;
}

.market_item5 {
    background:url("../../assets/image/m5_bg.png") no-repeat center;
    background-size:100% 100%;
    height:10.47rem;
}
.market_item5 .title{
    padding-top:0.9rem;
    margin-bottom:0.1rem;
    color: #fff;
}

.market_item5 ul{
    overflow: hidden;
    padding:0 0.15rem 0 0.35rem;
}
.market_item5 ul li {
    float: left;
    width: 3.3rem;
    height: 3.9rem;
    background: rgba(255,255,255,0.05);
    margin-right: 0.2rem;
    margin-top:0.2rem;
}
.market_item5 ul li i {
    display: block;
    width:1.12rem;
    height:1.12rem;
    margin:0 auto;
    margin-top:0.5rem;
}
.market_item5 ul li i img{
    display: block;
    width:1.12rem;
    height:1.12rem;
}
.market_item5 ul li h3 {
    font-size: 0.18rem;
    font-weight: 400;
    color: #FFFFFF;
    margin:0.3rem 0 0.26rem 0;
    text-align:center;
}
.market_item5 ul li p {
    width: 2.4rem;
    color: #FFFFFF;
    line-height: 0.32rem;
    font-size: 0.14rem;
    opacity: 0.53;
    margin:0 auto;
    text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/product/marketing.vue